export enum ContactMethod {
  Phone = 'Phone',
  WA = 'WA',
  Email = 'Email',
}
